import { createRouter, createWebHistory } from "vue-router"

import editor from '@/views/editor/index.vue'
import editor_home from '@/views/editor/homePage/index.vue'
import editor_scene from '@/views/editor/scenePage/index.vue'
import { prepareOpenedScene } from '@/helper/sceneLoginUrl.js'
import { restoreAuthReturnPath } from '@/helper/restoreAuthReturnPath.js'

const routes = [
  {
    path: '/',
    name: 'editor',
    component: editor,
    children: [
      // {path: '/', name: 'editor_home', component: editor_home},
      {path: '/:sceneId(\\d+)', name: 'scene_editor', component: editor_scene, props: true},
    ],
  }
]

// prepareOpenedScene drops an expired token and a stale return path before the
// library reads them. restoreAuthReturnPath then runs before createWebHistory()
// captures the URL — see the helpers.
prepareOpenedScene()
restoreAuthReturnPath()

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router